export function upperFirst (string: string | undefined | null): string {
  return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
}

export function includeIgnoreCase (text: string, searchTerm: string) {
  return text?.toLocaleLowerCase()?.includes(searchTerm?.toLocaleLowerCase());
}
